module.exports = __webpack_public_path__ + "img/authBg.50338fb.jpg";